import React from 'react';
import axios from 'axios';

// Material UI Imports
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';

//Route Imports
import { Link } from 'react-router-dom';

// Assets imports
import '../styles/Login.css';
import logo from '../assets/lexia_logo_960x160.jpg';



const theme = createMuiTheme({
  palette: {
    primary: {
      main: process.env.REACT_APP_PRIMARY_COLOR,
    },
  },
  typography: {
    useNextVariants: true,
  },
});

const paperStyle = {
  // Css to center the paper
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // General styles for paper
  width: "60%",
  height: "auto",
  padding: "2em",
  textAlign: 'center',
};

const buttonStyle = {
  marginTop: 20,
  width: "90px",
  marginLeft: 10,
  float: "Right"
};

class Identify extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    }
  }

  handleClick(event) {
    // var apiBaseUrl = process.env.REACT_APP_LOGIN_URI;
    var apiBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL + '/passwords';


    // check another name for this
    var temp = this;

    axios.post(apiBaseUrl, {
      password: {
        email: this.state.email,
      }
    }).then(function (response) {
      if (response.data.status === "ok") {
        console.log("Email send")
        alert(response.data.message)
        temp.props.history.push("/");

      }
      else {
        alert(response.data.message)
      }
    }).catch(function (error) {
      alert(error)
      console.log(error);
    });
  }


  render() {
    return (
      <div className="Login">
        <MuiThemeProvider theme={theme}>
          <Paper style={paperStyle} elevation={3}>
            <img src={logo} className="Login-logo" alt="logo" />
            <h1 className="Login-title">Send reset password link</h1>
            <p>Please enter your email</p>
            <div>
              <div>
                <TextField
                  placeholder="Enter your Email"
                  label="Email"
                  onChange={(event) => this.setState({ email: event.target.value.toLowerCase(), })}
                  fullWidth={true}
                  variant="outlined"
                />
              </div>
              <div>
                <Button
                  variant="contained"
                  color="inherit"
                  style={buttonStyle}
                  component={Link}
                  to="/login"
                >Cancel</Button>
                <Button variant="contained"
                  color="primary"
                  style={buttonStyle}
                  onClick={(event) => this.handleClick(event)} >
                  Send</Button>
              </div>
            </div>
          </Paper>
        </MuiThemeProvider>
      </div>
    )
  }

}

export default Identify;


// WEBPACK FOOTER //
// src/components/Identify.js